/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThresholdAlertListModel {
    getFixupPrototypeFunction() { return ThresholdAlertListModel.fixupPrototype; }

    static newInstance(model: Partial<ThresholdAlertListModel>): ThresholdAlertListModel {
        let obj = Object.assign(new ThresholdAlertListModel(), model);
        ThresholdAlertListModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThresholdAlertListModel>): ThresholdAlertListModel {
        if (!model) return null;
        return ThresholdAlertListModel.newInstance(<ThresholdAlertListModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThresholdAlertListModel) {
        if (!obj) return;

        models.ThresholdAlertListModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThresholdAlertListModel): boolean {
        Object.setPrototypeOf(obj, ThresholdAlertListModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.threshold_percentage === undefined) {
            this.threshold_percentage = 0;
        }
        if (this.threshold_amount === undefined) {
            this.threshold_amount = 0;
        }
        if (this.alert_notification_details) {
            for (let val of this.alert_notification_details) {
                models.AlertNotificationDetailsModel.fixupPrototype(val);
            }
        }
    }

    /**
     * threshold id
     */
    id: string;

    /**
     * tenant id
     */
    tenant_id: string;

    /**
     * Name of the user who created the threshold alert.
     */
    created_by: string;

    /**
     * Created time to create threshold alert
     */
    created_at: string;

    /**
     * Name of the user who updated the the threshold alert.
     */
    updated_by: string;

    /**
     * Updated time to create threshold alert
     */
    updated_at: string;

    /**
     * threshold uri
     */
    threshold_uri: string;

    /**
     * threshold percentage
     */
    threshold_percentage: number;

    /**
     * threshold amount
     */
    threshold_amount: number;

    /**
     * Configuration type
     */
    configuration_type: string;

    /**
     * alert action details
     */
    alert_action_details: Array<string>;

    /**
     * threshold uri
     */
    budget_uri: string;

    /**
     * Threshold Action name
     */
    name: string;

    /**
     * Alert Notification Details
     */
    alert_notification_details: Array<models.AlertNotificationDetailsModel>;

}
